import { render, staticRenderFns } from "./PaymentDetailsTypeRendimento.vue?vue&type=template&id=719e85c4"
import script from "./PaymentDetailsTypeRendimento.vue?vue&type=script&lang=js"
export * from "./PaymentDetailsTypeRendimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports